<template>
  <div
    v-if="visible"
    class="alert-item-box"
    :class="boxClassName"
  >
    <i class="alert-item-box__icon iconhuice" :class="iconClassName"></i>
    <span class="alert-item-box__content">
      <slot name="title">{{title}}</slot>
    </span>
    <span class="alert-item-box__right-box">
      <span v-if="closable" @click="handleClose">
        <slot name="closeIcon">
          <i v-if="!closeText" class="iconhuice icon-guanbi"></i>
          <el-button v-else type="text">{{closeText}}</el-button>
        </slot>
      </span>
    </span>
  </div>
</template>

<script>
const INFO_MAP = {
  default: {
    icon: 'icon-xiaoxi',
  },
  success: {
    icon: 'icon-chenggong'
  },
  warning: {
    icon: 'icon-jinggao'
  },
  error: {
    icon: 'icon-cuowu'
  },

}

export default {
  name: 'HcAlertItem',
  props: {
    type: {
      type: String,
      default: 'default',
      validator(val) {
        return ['default', 'success', 'warning', 'error'].includes(val)
      },
    },
    size: {
      type: String,
      default: 'md',
      validator(val) {
        return ['md', 'sm'].includes(val)
      },
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: true,
    },
    closeText: {
      type: String,
      default: undefined,
    },
    effect: {
      type: String,
      default: 'light',
      validator(val) {
        return ['light', 'dark'].includes(val)
      },
    },
  },
  data() {
    return {
      visible: true,
    }
  },
  computed: {
    boxClassName() {
      return [
        `alert-item-box--type-${this.type}`,
        `alert-item-box--size-${this.size}`
      ]
    },
    activeInfoItem() {
      return INFO_MAP[this.type] || INFO_MAP.default
    },
    iconClassName() {
      return this.activeInfoItem.icon
    },
  },
  methods: {
    handleClose() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-item-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 16px;
  border-radius: 2px;

  .alert-item-box__icon {
    margin-right: 14px;
  }

  .alert-item-box__content {
    //
  }

  .alert-item-box__right-box {
    flex: 1;
    text-align: right;
    margin-left: 32px;
  }
}

.alert-item-box--type-default {
  background: #ebf0ff;
  border: 1px solid #b6c7ff;
  .alert-item-box__icon {
    color: $B6;
  }
}

.alert-item-box--type-success {
  background: #f6fff0;
  border: 1px solid #bff09c;

  .alert-item-box__icon {
    color: $S6;
  }
}
.alert-item-box--type-warning {
  background: #FFFAE6;
  border: 1px solid #FFE494;
  .alert-item-box__icon {
    color: $W6;
  }
}
.alert-item-box--type-error {
  background: #FFF3F0;
  border: 1px solid #FFCBC4;
  .alert-item-box__icon {
    color: $E6;
  }
}

.alert-item-box--size-md {
  height: 40px;
}

.alert-item-box--size-sm {
  height: 32px;
}
</style>
